export default "__VITE_ASSET__Dd6$bMaL__"